function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import classnames from "classnames";
import moment from "moment";
import GroupAvatar from "../../../../components/mui/material/GroupAvatar";
import UserAvatar from "../../../../components/mui/material/UserAvatar";
import { useThemeContext } from "../../../../contexts/ThemeContext";
var tKey = "features.Chat.Groups.GroupListItem";
function GroupListItem(_ref) {
  var group = _ref.group,
    selected = _ref.selected,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    theme = _useThemeContext.theme;
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var otherMembers = group.members.filter(function (member) {
    return member.user.id !== authUserId;
  });
  var typing = useSelector(function (state) {
    return state.entities.typings.byGroupId[group.id];
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTyping = _useState2[0],
    setShowTyping = _useState2[1];
  var timeoutId;
  useEffect(function () {
    if (!typing || moment.utc().diff(moment.utc(typing.createdAt), "milliseconds") >= 2000) return;
    setShowTyping(true);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return setShowTyping(false);
    }, 2000);
  }, [typing]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, {
    disablePadding: true
  }, /*#__PURE__*/React.createElement(ListItemButton, {
    selected: selected,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ListItemAvatar, null, group.multi ? /*#__PURE__*/React.createElement(GroupAvatar, {
    group: group
  }) : /*#__PURE__*/React.createElement(UserAvatar, {
    user: otherMembers[0].user
  })), /*#__PURE__*/React.createElement(ListItemText, {
    primaryTypographyProps: {
      component: "div"
    },
    secondaryTypographyProps: {
      component: "div"
    },
    primary: /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      flexGrow: 1,
      sx: {
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames({
        "bold-unread-message-light": selected && theme === "light",
        "bold-unread-message-dark": selected && theme === "dark"
      })
    }, group.name || otherMembers.map(function (member) {
      return member.user.fullName;
    }).join(","))), /*#__PURE__*/React.createElement(Box, {
      flexShrink: 0,
      marginLeft: 1
    }, /*#__PURE__*/React.createElement(Typography, {
      sx: {
        fontSize: "0.8125rem",
        fontWeight: 400,
        color: group.unreadMessageCount > 0 ? "#8b34a7" : "#787878"
      }
    }, moment(group.lastMessage.createdAt).format("hh:mm a")))),
    secondary: /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      flexGrow: 1,
      sx: {
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }, showTyping ? /*#__PURE__*/React.createElement("span", {
      className: "text-brand-primary",
      style: {
        fontWeight: 500
      }
    }, t("".concat(tKey, ".typing"), {
      username: typing.userUsername
    })) : group.lastMessage ? /*#__PURE__*/React.createElement("span", {
      className: classnames({
        "bold-unread-message-light": selected && theme === "light",
        "bold-unread-message-dark": selected && theme === "dark"
      }),
      style: {
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: "#787878"
      }
    }, group.multi ? "@".concat(group.lastMessage.user.username, ": ") : "", group.lastMessage.text) : /*#__PURE__*/React.createElement("span", {
      style: {
        fontStyle: "italic"
      }
    }, t("".concat(tKey, ".noMessage")))), group.unreadMessageCount > 0 && /*#__PURE__*/React.createElement(Box, {
      flexShrink: 0,
      marginLeft: 1
    }, /*#__PURE__*/React.createElement(Avatar, {
      sx: {
        width: "24px",
        height: "24px",
        fontSize: "0.75rem",
        backgroundColor: "#8b34a7",
        color: "white"
      }
    }, group.unreadMessageCount)))
  }))), /*#__PURE__*/React.createElement(Divider, {
    component: "li"
  }));
}
export default GroupListItem;